export default "__VITE_ASSET__tTxvt4fz__"